import { createBraze, type BrazeClient, type SubscriptionState } from '@/services/braze/index';

let clientPromise: Promise<BrazeClient> | null = null;
let started = false;

export async function startBrazeIfConsented(consented: boolean) {
    if (!consented || started) return;
    if (!clientPromise) clientPromise = createBraze();
    const client = await clientPromise;
    await client.start(process.env.VUE_APP_BRAZE_API_KEY || '', process.env.VUE_APP_BRAZE_BASE_URL || '', {
        serviceWorker: '/braze-service-worker.js',
        logging: process.env.NODE_ENV === 'development',
    });
    started = true;
}

export async function identifyBrazeUser(externalId: string, email?: string, subs?: { push?: SubscriptionState; email?: SubscriptionState }) {
    if (!clientPromise) clientPromise = createBraze();
    const client = await clientPromise;
    client.changeUser(externalId);
    if (email) client.setEmail(email);
    if (subs) client.setSubscriptions(subs);
}

export async function trackBrazeEvent(name: string, props?: Record<string, unknown>) {
    if (!clientPromise) clientPromise = createBraze();
    const client = await clientPromise;
    client.logEvent(name, props);
}

export async function refreshContentCards(): Promise<void> {
    if (!clientPromise) clientPromise = createBraze();
    const client = await clientPromise;
    await client.requestContentCardsRefresh();
}

export async function getContentCards() {
    if (!clientPromise) clientPromise = createBraze();
    const client = await clientPromise;
    return client.getContentCards();
}
